module.exports = __webpack_public_path__ + "static/img/SketchPng3671963937ffd1b372d4c62cb5be1b7fe9b81ca7abaef4471a12bd51cf62b56e.84953e35.png";